module.exports = __webpack_public_path__ + "media/images/lp-flow-step-3@2x-b575de2176ba275af248ce3955530793.png";